// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionTitle_wrapper__QdJMl","title":"SectionTitle_title__cSJUv","underline":"SectionTitle_underline__LTh4n"};